import React from 'react';
import { Button, Checkbox, Form, Input, InputNumber, Select, Switch } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { myExternals, sendDataBody, usuario } from '../../resources';


// PARENT: visitas.modal.jsx

export default function VisitaTratamientoK({ medico, id_paciente, tipo_visita, setIsModalOpen }) {

    const onFinish = values => {
        values.id_paciente = id_paciente;
        values.tipo_visita = tipo_visita
        sendDataBody('visitas/add', values).then(() => setIsModalOpen(false))
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    return (
        <div>
            <br />
            <span>Primero, debe llenar la solicitud de tratamiento {tipo_visita}</span>
            <br />
            <br />

            <Form
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                    label="Cantidad de sesiones"
                    name="numero_sesiones"
                    rules={[{ required: true, message: 'Please input your username!' }]}
                >
                    <InputNumber />
                </Form.Item>

                <Form.Item
                    label="Historial relevante"
                    name="historial_relevante"
                    rules={[{ required: true, message: 'Please input your username!' }]}
                >
                    {/* <Input /> */}
                    <Checkbox.Group
                        options={[
                            { value: 'Epilepsia o crisis convulsivas', label: <span>Epilepsia o crisis convulsivas</span> },
                            { value: 'Implantes metálicos en la cabeza', label: <span>Implantes metálicos en la cabeza</span> },
                            { value: 'Enfermedades pulmonares', label: <span>Enfermedades pulmonares</span> },
                            { value: 'Migraña cronica cefalea severa', label: <span>Migraña cronica cefalea severa</span> },
                            { value: 'Hipertensión arterial', label: <span>Hipertensión arterial</span> },
                            { value: 'Abuso de sustancias', label: <span>Abuso de sustancias</span> },
                            { value: 'Enfermedad hepática grave', label: <span>Enfermedad hepática grave</span> },
                            { value: 'Enfermedad cardiovascular', label: <span>Enfermedad cardiovascular</span> },
                            { value: 'Ninguna de las anteriores', label: <span>Ninguna de las anteriores</span> },
                        ]} />
                </Form.Item>

                <Form.Item
                    label="Tratamientos previos"
                    name="tratamientos_previos"
                    rules={[{ required: true, message: 'Please input your username!' }]}
                >
                    {/* <Input /> */}
                    <Checkbox.Group options={[
                        { value: 'Antidepresivos', label: <span>Antidepresivos</span> },
                        { value: 'Neuromodulacion', label: <span>Neuromodulacion</span> },
                        { value: 'Antipsicóticos', label: <span>Antipsicóticos</span> },
                        { value: 'Psicoterapia', label: <span>Psicoterapia</span> },
                        { value: 'Ninguna de las anteriores', label: <span>Ninguna de las anteriores</span> }
                    ]} />
                </Form.Item>

                <Form.Item
                    label="Medicacion actual"
                    name="medicacion_actual"
                    rules={[{ required: true, message: 'Please input your username!' }]}
                >
                    {/* <Input /> */}
                    <Checkbox.Group options={[
                        { value: 'Antidepresivos', label: <span>Antidepresivos</span> },
                        { value: 'Bupropión', label: <span>Bupropión</span> },
                        { value: 'Benzodiacepinas', label: <span>Benzodiacepinas</span> },
                        { value: 'Analgesicos opiaceos', label: <span>Analgesicos opiaceos</span> },
                        { value: 'Antipsicóticos', label: <span>Antipsicóticos</span> },
                        { value: 'Antilépticos', label: <span>Antilépticos</span> },
                        { value: 'Ninguna de las anteriores', label: <span>Ninguna de las anteriores</span> }
                    ]} />
                </Form.Item>

                {/* <Form.Item
                    label="Medico que aprueba"
                    rules={[{ required: true, message: 'El medico que aprueba es requerido!' }]}
                    initialValue={medico?.name || 'No asignado'}
                >
                    <span style={{ fontWeight: 'bold' }}>{medico?.name || 'No asignado'}</span>
                </Form.Item> */}


                <Form.Item
                    label="Médico que refiere"
                    name="medico_refiere"
                    rules={[{ required: false, message: 'Please input your username!' }]}
                >

                    <Input />

                </Form.Item>

                <Form.Item
                    label="Aprobado"
                    name="aprobado"
                    rules={[{ required: false, message: 'Please input your username!' }]}
                >
                    <Switch />
                </Form.Item>

                <Form.Item
                    label="Precio"
                    name="precio"
                    rules={[{ required: true, message: 'Please input your username!' }]}
                >
                    <InputNumber />
                </Form.Item>

                <div style={{ position: 'absolute', right: 16, bottom: 16 }}>
                    <Button onClick={() => setIsModalOpen(false)}>Cancelar</Button>
                    <Button type="primary" htmlType="submit">
                        Guardar
                    </Button>
                </div>
            </Form>

        </div>
    )
}
